/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SbSharedRefineMenuFilterPeriod_itemSearch = {
    readonly " $fragmentRefs": FragmentRefs<"SbSharedRefineMenuMultiSelectList_itemSearch">;
    readonly " $refType": "SbSharedRefineMenuFilterPeriod_itemSearch";
};
export type SbSharedRefineMenuFilterPeriod_itemSearch$data = SbSharedRefineMenuFilterPeriod_itemSearch;
export type SbSharedRefineMenuFilterPeriod_itemSearch$key = {
    readonly " $data"?: SbSharedRefineMenuFilterPeriod_itemSearch$data;
    readonly " $fragmentRefs": FragmentRefs<"SbSharedRefineMenuFilterPeriod_itemSearch">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "SbSharedRefineMenuFilterPeriod_itemSearch",
  "type": "ItemSearchQueryConnection",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuMultiSelectList_itemSearch",
      "args": null
    }
  ]
};
(node as any).hash = 'b53ed5e16fdfef2179e72500a89c77d7';
export default node;
